// 데스크탑 좌우 분할 레이아웃 — Phase 1-2 후속 v2
//   좌(35%): AttendanceDesktopSummaryList — 직원 리스트 (10명 페이지네이션)
//   우(65%): AttendanceCalendarPanel + AttendanceListPanel
//     · 캘린더는 직원 미선택 시에도 항상 표시 (출근 인원 수 모드)
//     · 리스트는 직원 미선택 시 전체, 선택 시 그 직원만 (10건 페이지네이션)
//   selectedUserId / selectedDate 상위(AttendanceManagement)에서 관리
import React from 'react';
import { AttendanceDesktopSummaryList } from './AttendanceDesktopSummaryList';
import { AttendanceCalendarPanel } from './AttendanceCalendarPanel';
import { AttendanceListPanel } from './AttendanceListPanel';

export function AttendanceDesktopLayout({
  groupedByUser, year, month,
  selectedUserId, setSelectedUserId,
  selectedDate, setSelectedDate,
  todayYmd, holidays, leaveByDate, onEdit,
}) {
  const userGroup = selectedUserId ? groupedByUser[selectedUserId] : null;
  // 좌우 stretch — 좌측(직원 리스트) 높이 = 우측(캘린더+리스트) 높이 → 페이지네이션 같은 줄
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 35fr) minmax(0, 65fr)', gap: 12, alignItems: 'stretch', minWidth: 0 }}>
      {/* 좌: 직원 리스트 (10명 페이지네이션, 페이지네이션은 marginTop:auto로 하단 push) */}
      <AttendanceDesktopSummaryList
        groupedByUser={groupedByUser}
        selectedUserId={selectedUserId}
        onSelectUser={(uid) => {
          if (String(selectedUserId) === String(uid)) { setSelectedUserId(null); setSelectedDate(null); return; }
          setSelectedUserId(uid); setSelectedDate(null);
        }}
      />
      {/* 우: 캘린더 + 리스트 — 리스트 1fr로 늘어나 좌측 높이와 매칭 (캘린더는 셀 고정 높이 → 일정) */}
      <div style={{ display: 'grid', gridTemplateRows: 'auto 1fr', gap: 12, minWidth: 0 }}>
        <AttendanceCalendarPanel
          year={year} month={month}
          userGroup={userGroup}
          groupedByUser={groupedByUser}
          selectedDate={selectedDate}
          onSelectDate={setSelectedDate}
          onEditDay={onEdit}
          todayYmd={todayYmd}
          holidays={holidays}
          leaveByDate={leaveByDate}
        />
        <AttendanceListPanel
          groupedByUser={groupedByUser}
          selectedUserId={selectedUserId}
          onEdit={onEdit}
        />
      </div>
    </div>
  );
}
